import React, { useState, useEffect } from 'react';
import 'bulma/css/bulma.min.css';
import InviteForm from '../pages/invite';
import EditForm from '../pages/EditInvite';
import { Config } from '../.env.js';
import { useLocation } from 'react-router-dom';

const UserTable = () => {
    const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const location = useLocation();

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch(`${Config.API_URL}/api/users`);
                if (!response.ok) throw new Error('Failed to fetch users');
                const usersData = await response.json();
                setUsers(usersData);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };

        fetchUsers();
    }, []);

    const handleEditClick = (user) => {
        setSelectedUser(user);
        setIsEditModalOpen(true);
    };

    const updateUserTable = (updatedUser) => {
        setUsers((prevUsers) =>
            prevUsers.map((user) => (user._id === updatedUser._id ? updatedUser : user))
        );
    };

    return (
        <div className="container">
            <table className="table is-bordered is-hoverable is-fullwidth">
                <thead>
                    <tr>
                        <th className="has-text-left">User</th>
                        <th className="has-text-left">Role</th>
                        <th className="has-text-left">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(user => (
                        <tr key={user._id}>
                            <td className="has-text-left">
                                <div className="columns is-mobile is-vcentered">
                                    <div className="column is-narrow">
                                        <span className="icon is-small">
                                            <i className="fas fa-user"></i>
                                        </span>
                                    </div>
                                    <div className="column">
                                        <strong>{user.userName}</strong>
                                        <div className="has-text-grey-light" style={{ fontSize: '0.9em' }}>
                                            {user.email}
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td className="has-text-left">{user.role}</td>
                            <td className="has-text-left">
                                <button className="button is-primary is-small" onClick={() => handleEditClick(user)}>
                                    Edit
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Invite Form Modal */}
            {isInviteModalOpen && (
                <InviteForm
                    closeModal={() => setIsInviteModalOpen(false)}
                    updateUserTable={updateUserTable}
                />
            )}

            {/* Edit Form Modal */}
            {isEditModalOpen && (
                <EditForm
                    closeModal={() => setIsEditModalOpen(false)}
                    selectedUser={selectedUser}
                    updateUserTable={updateUserTable}
                />
            )}
        </div>
    );
};

export default UserTable;
